export const Base_URL ="https://taskexhibitor.onrender.com/api";

export const METHOD_TYPE = {
    GET: "GET",
    POST: "POST",
    PUT: "PUT",
    DELETE: "DELETE",
    PATCH: "PATCH",
}